<span>
    <router-outlet></router-outlet>
    <!-- Se muestra el chat solo si hay token -->
    <app-chat *ngIf="isLoggedIn && !isAdmin" [selectedReference]="selectedReference" [isChatOpen]="chatOpen"
        (chatClose)="cambiarEstadoChat($event)"></app-chat>
</span>